let alertSoundInstalled = false;

const DEFAULT_SOUND_URL = "/sound.mp3";
const ERROR_SOUND_URL = "/error5.mp3";
const OPEN_SOUND_URL = "/open.mp3";
const CONTACT_OPEN_SOUND_URL = "/support/contactopen.MP3";
const SOUND_MUTE_STORAGE_KEY = "awsmivent.notificationSoundMuted";

const readMutedState = () => {
  try {
    if (typeof window === "undefined") return false;
    return window.localStorage.getItem(SOUND_MUTE_STORAGE_KEY) === "true";
  } catch (error) {
    return false;
  }
};

export const isNotificationSoundMuted = () => readMutedState();

export const setNotificationSoundMuted = (muted) => {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(
      SOUND_MUTE_STORAGE_KEY,
      muted ? "true" : "false",
    );
  } catch (error) {
    // Non-critical.
  }
};

const playSound = (soundUrl) => {
  try {
    if (typeof Audio === "undefined" || readMutedState()) return;
    const audio = new Audio(soundUrl || DEFAULT_SOUND_URL);
    audio.volume = 0.5;
    audio.play().catch(() => {
      // Ignore autoplay restrictions or missing user interaction.
    });
  } catch (error) {
    // Non-critical.
  }
};

export const playInfoSound = () => playSound(DEFAULT_SOUND_URL);

export const playErrorSound = () => playSound(ERROR_SOUND_URL);

export const playOpenSound = () => playSound(OPEN_SOUND_URL);

export const playContactOpenSound = () => playSound(CONTACT_OPEN_SOUND_URL);

export const installAlertSound = () => {
  if (alertSoundInstalled || typeof window === "undefined") {
    return;
  }

  alertSoundInstalled = true;

  const nativeAlert = window.alert?.bind(window);
  if (typeof nativeAlert !== "function") {
    return;
  }

  window.alert = (message) => {
    playErrorSound();
    nativeAlert(message);
  };
};

export default installAlertSound;
